import React from "react";
import { useDispatch, useSelector } from "react-redux";
import pin from "../../static/icons/pin.png"
import unpin from "../../static/icons/unpin.png"
import { entryUpdate } from "../../api/entryAPI";
import DataTable from "./DataTable";

function EntryTable(props) {
    const dateString = props.date.split("T")[0];
    const dispatch = useDispatch();
    const token = useSelector(state => state.user.token)

    const handleUpdate = () => {
        const submitData = {
            pinned: !props.pinned,
            breakID: props.breakID
        }
        dispatch(entryUpdate({token, id: props.entryID, submitData}))
    }

    return(
        <div className="my-3 relative">
            <div className="x-divider"></div>

            <div className="flex my-4">
                <h2 className="text-xl sm:text-xl">{dateString} <br></br>{props.startTime} - {props.endTime}</h2>

                <div className="flex flex-row items-center p-2 zoom border-primary absolute right-0" onClick={() => handleUpdate()}>
                    {props.pinned ? <img src={unpin} alt="unpin" className="w-6"/> : <img src={pin} alt="pin" className="w-6"/>}
                </div>
            </div>

            {props.buoyData.map(buoy => {
                return(
                    <DataTable 
                        key={Math.floor(Math.random() * 10000000)}
                        buoyId={buoy.buoyId}
                        meteorological={buoy.meteorological}
                        spectral={buoy.spectral}
                    />
                )
            })}
            {props.notes && <div className="notebook"><p className="">{props.notes}</p></div>}
        </div>
    )

}

export default EntryTable;